import React from 'react'
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
const HobbyClubs = () => {
  return (
    <>
      <HeadTag title="Hobby Clubs" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span> Co-Curricular  <i className="fas fa-angle-right"></i>  Hobby Clubs </span></h5>
            <h2>  Hobby Clubs </h2>
          </div>
          <p>We at LVIS, Noida Extension believe that sports and co-curricular activities play a vital role in the holistic development of children and also form the basis of pre-vocational skills.The school has introduced various Hobby Clubs from the academic session 2018-19 for Classes I-IX. These Clubs will help in identifying and fostering the creativity of students, beyond academics.</p>
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <h3>Classes I & II</h3>
              <div className="innertable">
                <table width="100%;" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>Spotlight</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Creative Hive</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>Creative Cuisines</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Melody Makers (Western Music)</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Swar & Symphony (Indian Music)</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Happy Feet (Western Dance)</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Taal Tarang (Indian Dance)</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Yogic Dreamers</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Abacus Whiz</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Pottery And Clay Modelling: Clay Crafters</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Kalakriti</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


            <div className="col-lg-6 col-md-12">
              <h3>Classes III</h3>
              <div className="innertable">
                <table width="100%" cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>BEYOND THE STARS - ASTRONOMY CLUB</td>
                    </tr>
                    <tr>
                      {/* <td colSpan={2}><b>Non-Paid Club Activities</b></td> */}
                    </tr>
                    
                    <tr>
                      <td>2</td>
                      <td>POTTERY CLUB</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>NATURE NURTURE - ENVIRONMENTAL CLUB</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>ART ATTACK - ART CLUB</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>HASTKALA CLUB</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>CULINARY DELIGHT - FIRELESS COOKING CLUB</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>EXPRESSIONS - THEATRE AND DRAMA CLUB</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>WORDSWORTH - LANGUAGE CLUB</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>DANCEPIRATION - INDIAN DANCE CLUB</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>BITS AND BYTES - ICT CLUB</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>ABSOLUTE FIT - FITNESS CLUB</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>ABACUS CLUB</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <h3>Classes IV–V</h3>
              <div className="innertable">
                <table width="100%" cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>BEYOND THE STARS - ASTRONOMY CLUB</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>STEM ROBO CLUB (ONLY GRADE V)</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>PUBLIC SPEAKING AND DEBATE CLUB</td>
                    </tr>
                    <tr>
                      {/* <td colSpan={2}><b>Non-Paid Club Activities</b></td> */}
                    </tr>

                    <tr>
                      <td>4</td>
                      <td>PARAMPARA - HERITAGE CLUB</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>NATURE NURTURE - ENVIRONMENTAL CLUB</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>ART ATTACK - ART CLUB</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>CULINARY DELIGHT - FIRELESS COOKING CLUB</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>DANCEPIRATION - INDIAN DANCE CLUB (GRADE IV ONLY)</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>ABSOLUTE FITNESS - FITNESS CLUB</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>ABACUS CLUB</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>POTTERY AND CLAY MODELLING CLUB</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>HASTKALA CLUB</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>WORDSWORTH</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* <div className="col-lg-6 col-md-12">
              <h3>Classes III</h3>
              <div className="innertable">
                <table width="100%;" cellpadding="0" cellspacing="0">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>ABACUS</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>'BEYOND THE STARS' - ASTRONOMY CLUB</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>FINANCIAL LITERACY</td>
                    </tr>

                    <tr>
                      <td>4</td>
                      <td>'NATURE NURTURE'- ENVIRONMENTAL CLUB</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>'ART ATTACK'- ART CLUB</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>'CRAFTY HANDS'- ORIGAMI CLUB</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>'CULINARY DELIGHT'- FIRELESS COOKING CLUB</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>'EXPRESSIONS' - THEATRE AND DRAMA CLUB</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>'DANCEPIRATION'- DANCE CLUB</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>'BITS AND BYTES'- ICT CLUB</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>'ABSOLUTE FIT'- FITNESS CLUB</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <h3>Classes IV to V</h3>
              <div className="innertable">
                <table width="100%;" cellpadding="0" cellspacing="0">

                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>'ABACUS'</td>
                    </tr>
                    <tr className="success">
                      <td>2</td>
                      <td>'BEYOND THE STARS' - ASTRONOMY CLUB</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>POTTERY AND CLAY MODELLING CLUB</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>STEM ROBO CLUB</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>PUBLIC SPEAKING AND DEBATE CLUB</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>'EXPRESSIONS'- THEATRE AND DRAMA CLUB</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>FINANCIAL LITERACY</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>'PARAMPARA'- HERITAGE CLUB</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>'NATURE NURTURE'-ENVIRONMENTAL CLUB</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>'ART ATTACK'- ART CLUB</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>'CULINARY DELIGHT'- FIRELESS COOKING CLUB</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>'DANCEPIRATION'- DANCE CLUB (GRADE IV ONLY)</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>'ABSOLUTE FITNESS' - FITNESS CLUB</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}
            <div className="col-lg-6">
              <h3>Classes VI TO X</h3>
              <div className="innertable">
                <table width="100%;" cellpadding="0" cellspacing="0">

                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>Vedic Math Club: Math Mantra</td>
                    </tr>
                    <tr className="success">
                      <td>2</td>
                      <td>Pottery and Clay Modelling Club: Clay Crafters</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>STEM Robo Club: Tech Titans</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>Space and Astronomy Club: Beyond the Stars</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>Model United Nations (MUN): MUN Saga</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>Public Speaking and Debate Club: Orator’s Oasis</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>Theatre and Drama Club: Expressions</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>Photography Club: Clicked! </td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>Eco Club: Prakriti</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>Culinary Club: Flavourful Fusion</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>Wordsworth: Crafting Creative Realms</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>Inquisitive: Quest for Knowledge</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td>Needlework: Threads of Art</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <h3>Classes IX–XII</h3>
              <div className="innertable">
                <table width="100%" cellPadding="0" cellSpacing="0">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody className="text-left">
                    <tr>
                      <td>1</td>
                      <td>STEM ROBO CLUB - Tech Titans</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>SPACE AND ASTRONOMY CLUB - Beyond the Stars</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>MODEL UNITED NATIONS (MUN) - MUN Saga</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>PUBLIC SPEAKING AND DEBATE CLUB - Orator’s Oasis</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>PHOTOGRAPHY CLUB - Clicked!</td>
                    </tr>
                    <tr>
                      {/* <td colSpan={2}><b>Non-Paid Club Activities</b></td> */}
                    </tr>


                    <tr>
                      <td>6</td>
                      <td>ECO CLUB - Prakriti</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>POTTERY AND CLAY MODELLING CLUB - Clay Crafters</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>THEATRE AND DRAMA CLUB - Expressions</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td>CULINARY CLUB - Flavourful Fusion</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>WORDSWORTH - Crafting Creative Realms</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td>INQUISITIVE - Quest for Knowledge</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td>NEEDLEWORK - Threads of Art</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default HobbyClubs
